export default {
    count_active: 'Aktivieren Sie Ihr Konto!',
    days: 'Tage.',
    expired: 'Ihr Testzeitraum ist abgelaufen, aktivieren Sie Ihr Konto!',
    you_have: 'Sie haben ',
    take_session: ' Um Ihre kostenlose Schulung zu buchen.',
    take_now: ' Jetzt buchen.',
}